import {
    NOTICE_TYPE_LIST_RESPONCE,
    EDIT_REDUX_STATE,
    DELETE_REDUX_STATE,
    EDIT_STATUS_REDUX_STATE,
    EDIT_SIGN_STATUS_REDUX_STATE

} from "./actionTypes";

const INIT_STATE = {
    noticeList: []
};

/**
 * Reducer function for managing the state of the NoticeType.
 * @param {Object} state - The current state of the NoticeType.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns The updated state based on the action type.
 */
const NoticeType = (state = INIT_STATE, action) => {
    switch (action.type) {

        case NOTICE_TYPE_LIST_RESPONCE:
           
            state = {
                ...state,
                noticeList: action.payload,
              }
              return state;
        case  EDIT_REDUX_STATE:
                state = {
                    ...state,
                    noticeList:{data : action.payload},
                    }
                    return state;
         case  DELETE_REDUX_STATE:
                 state = {
                     ...state,
                     noticeList: {data:action.payload},
                   }
                     return state;
         case  EDIT_STATUS_REDUX_STATE:
                state = {
                     ...state,
                      noticeList:{data : action.payload},
                      }
                    return state;
         case  EDIT_SIGN_STATUS_REDUX_STATE:
                 state = {
                     ...state,
                     noticeList:{data : action.payload},
                      }
                            return state;
        default:
            return state;
    }
};


export default NoticeType;